import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const MyProfile = ({match}) => (
  <div className="app-wrapper">
    <Switch>
      <Route path={`${match.url}/profile`} component={asyncComponent(() => import('./routes/Profile/index'))}/>
       <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default MyProfile;